import React from 'react';
import { Box } from '@mui/material';

// Import the components
import Banner from '../components/Banner';
import FAQSection from '../components/FAQSection';
import RoadmapSection from '../components/RoadmapSection';
import StoryPoint from '../components/StoryPoint';

// Import SVG files directly
import { ReactComponent as ProblemFigure } from '../assets/problem_figure.svg';
import { ReactComponent as SolutionFigure } from '../assets/solution_figure.svg';

// Import text content
import { landingTexts } from '../texts/landing';

// Main Landing Page Component
const Landing = () => {
  const buildProblemHTML = () => {
    const { content } = landingTexts.storyPoints.problem;
    return `
      <p>${content.paragraph}</p>
      <ul>
        ${content.listItems.map(item => `<li>${item}</li>`).join('')}
      </ul>
    `;
  };

  const buildSolutionHTML = () => {
    const { content } = landingTexts.storyPoints.solution;
    return `
      <p>${content.paragraph}</p>
      <p></p>
      <ol>
        ${content.listItems.map(item => `<li>${item}</li>`).join('')}
      </ol>
    `;
  };

  return (
    <Box sx={{ 
      bgcolor: 'grey.50'
    }}>
      <Banner 
        title={landingTexts.banner.title}
        subtitle={landingTexts.banner.subtitle}
      />
      
      {/* First StoryPoint with regular layout and HTML content */}
      <StoryPoint
        title={landingTexts.storyPoints.problem.title}
        body={buildProblemHTML()}
        image={<ProblemFigure />}
        reverse={false}
        bgcolor='background.paper' 
      />
      
      {/* Second StoryPoint with reversed layout and HTML content */}
      <StoryPoint
        title={landingTexts.storyPoints.solution.title}
        body={buildSolutionHTML()}
        image={<SolutionFigure />}
        reverse={true}
        bgcolor='background.default'  
      />
      
      <FAQSection 
        title={landingTexts.faq.title}
        items={landingTexts.faq.items}
      />
      <RoadmapSection 
        title={landingTexts.roadmap.title}
        items={landingTexts.roadmap.items}
      />
    </Box>
  );
};

export default Landing;